<script setup>
import { ref } from 'vue'

const socials = ref([
	{
		label: 'Instagram',
		icon: 'fab fa-instagram',
		href: 'https://www.instagram.com/logitechg',
	},
	{
		label: 'X',
		icon: 'fab fa-x-twitter',
		href: 'https://x.com/LogitechG',
	},
	{
		label: 'Facebook',
		icon: 'fab fa-facebook-f',
		href: 'https://www.facebook.com/LogitechG',
	},
	{
		label: 'YouTube',
		icon: 'fab fa-youtube',
		href: 'https://www.youtube.com/logitechg',
	},
	{
		label: 'Discord',
		icon: 'fab fa-discord',
		href: 'https://discord.com/invite/LogitechG',
	},
])
const links = ref([
	{
		label: 'Terms of Use',
		href: 'https://www.logitech.com/en-gb/tos/terms',
	},
	{
		label: 'Privacy Policy',
		href: 'https://www.logitech.com/en-gb/legal/privacy-policy',
	},
	{
		label: 'Cookie Policy',
		href: 'https://www.logitech.com/en-gb/legal/cookie-policy',
	},
])
</script>

<template>
	<footer class="bg-logi-grey-500 py-10 md:pb-40">
		<div class="container">
			<div class="flex flex-col justify-between gap-10 md:flex-row md:gap-0">
				<div class="flex flex-col items-center gap-4 md:items-start">
					<img src="https://d21cpkouqu9xdo.cloudfront.net/images/logos/logitech-g.svg" alt="Logitech G Logo" class="relative h-8 md:h-10" />
					<div class="flex gap-3">
						<a class="flex h-8 w-8 items-center justify-center rounded-full bg-logi-grey-400 text-sm text-white transition-colors duration-200 hover:bg-logi-grey-300 md:h-10 md:w-10 md:text-base" v-for="social in socials" :href="social.href" target="_blank"><i :class="social.icon" /></a>
					</div>
				</div>
				<div class="flex flex-col items-center gap-3 md:items-end">
					<p class="text-white/70">&copy; {{ new Date().getFullYear() }} Logitech. All rights reserved.</p>
					<div class="flex flex-col items-center xs:flex-row xs:gap-5">
						<a class="font-poppins py-1 text-sm font-bold uppercase" v-for="link in links" :href="link.href" target="_blank">{{ link.label }}</a>
					</div>
					<button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie settings</button>
				</div>
			</div>
		</div>
	</footer>
</template>
